import React, { FC } from 'react';
import './Logo.css';

interface LogoProps {}

const Logo: FC<LogoProps> = () => (
  <div className="Logo" data-testid="Logo">
    <img className='Logo__image large-logo' src="/large-LOGO-ICAZI-V4.png" alt="Logo" />
    <img className='Logo__image min-logo' src="/min-LOGO-ICAZI-V4.png" alt="Logo" />
  </div>
);

export default Logo;
